export default function AboutSection({ isVisible }) {
  return (
    <section
      id="about"
      className={`py-24 lg:py-32 bg-[#F9F6F0] transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="lg:col-span-2">
            <div className="relative max-w-md mx-auto lg:mx-0">
              <img
                src="https://customer-assets.emergentagent.com/job_drama-for-work/artifacts/q61jtyna_WhatsApp%20Image%202026-04-05%20at%2013.17.46.jpeg"
                alt="Manisha at 10 Downing Street"
                className="w-full h-auto object-cover"
                data-testid="about-image"
              />
              {/* Decorative corner */}
              <div className="absolute -bottom-4 -left-4 w-20 h-20 border-l-2 border-b-2 border-[#C5A059]"></div>
            </div>
          </div>

          {/* Text Content */}
          <div className="lg:col-span-3">
            <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1A1A1A] mb-8 heading-decorated">
              About Manisha
            </h2>

            <div className="prose-creative space-y-5">
              <p className="font-['Manrope'] text-base lg:text-lg text-[#4A4542] leading-relaxed">
                Manisha is a creative producer and facilitator with over a decade of
                experience in arts and culture, including senior roles at the{" "}
                <span className="font-semibold text-[#1A1A1A]">National Theatre</span>.
              </p>

              <p className="font-['Manrope'] text-base lg:text-lg text-[#4A4542] leading-relaxed">
                Her work sits at the intersection of theatre, communication and human
                development, drawing on rehearsal-room practices to help people build
                confidence, presence and self-awareness.
              </p>

              <p className="font-['Manrope'] text-base lg:text-lg text-[#4A4542] leading-relaxed">
                She is currently developing her facilitation practice through
                specialist training in drama-based approaches and is particularly
                interested in how creative methods can support communication,
                leadership and psychological safety in the workplace.
              </p>

              <p className="font-['Manrope'] text-base lg:text-lg text-[#4A4542] leading-relaxed">
                With a BA in English & Theatre from De Montfort University and
                extensive training in acting, voice work, and improvisation, Manisha
                brings a unique blend of artistic expertise and practical facilitation
                skills to her work.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
